import { useEffect, useState } from "react";

export const PALETTES = [
  {
    id: "slate",
    name: "Obsidian Slate",
    description: "Classic high-tech navy & electric iris",
    color: "#4f46e5",
    accentLight: "#4f46e5",
    accentDark: "#818cf8",
    bgLight: "#f8fafc",
    bgDark: "#0b0f19",
  },
  {
    id: "salmon",
    name: "Tuscan Salmon",
    description: "Warm terracotta, linen & coral glow",
    color: "#cb4d2e",
    accentLight: "#cb4d2e",
    accentDark: "#f16e4e",
    bgLight: "#f7f3ed",
    bgDark: "#191210",
  },
  {
    id: "orange",
    name: "Amber Sunset",
    description: "Golden honey, cashmere sand & radiant ember",
    color: "#dc7b04",
    accentLight: "#dc7b04",
    accentDark: "#f89917",
    bgLight: "#f8f5ee",
    bgDark: "#16120f",
  },
  {
    id: "sage",
    name: "Nordic Sage",
    description: "Serene eucalyptus mist & luminous spruce",
    color: "#0d9488",
    accentLight: "#0d9488",
    accentDark: "#34d399",
    bgLight: "#f3f7f5",
    bgDark: "#0c1512",
  },
];

export function useTheme() {
  const [theme, setTheme] = useState(() => localStorage.getItem("ezjob_theme") || "dark");
  const [palette, setPalette] = useState(() => localStorage.getItem("ezjob_palette") || "slate");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    localStorage.setItem("ezjob_theme", theme);
  }, [theme]);

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-palette", palette);
    localStorage.setItem("ezjob_palette", palette);
  }, [palette]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return {
    theme,
    setTheme,
    toggle,
    palette,
    setPalette,
    palettes: PALETTES,
  };
}
